import React from 'react'
import Tooltip from 'rc-tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import DropDown from '../../misc/dropdown/DropDown'

if (typeof window !== 'undefined') {
  require('rc-tooltip/assets/bootstrap.css')
}

export default ({title, cost, items, className, action, onClick, disabled, durationOptions, duration, frequency, description, banner}) => (
  <div key={title} className={`plan ${className}`}>
    {banner ? <div className="banner">{banner}</div> : ''}
    <div className="plan-title">{title}</div>
    <div className="plan-cost">
      <div>{cost}</div>
      <div className="plan-cost-details">
        <div className="plan-month">{frequency ? frequency : 'per month'}</div>
        {durationOptions ?
          <DropDown
            position="bottom center"
            className="duration-options"
            items={durationOptions}
          >
            billed annually <span style={{'marginLeft': '4px'}}><FontAwesomeIcon icon={faCaretDown} /></span>
          </DropDown>
        : 
          <div className="duration-options duration-options-static">
            {duration}
          </div>
        }
      </div>
    </div>
    <div className="plan-description">{description}</div>
    <div className="features">
    {items.map(item => (
      <div className="feature">
        <span dangerouslySetInnerHTML={{__html: item.name}} />
        {item.description ? 
          <div className="plan-info">
            <Tooltip placement="right" overlay={<span dangerouslySetInnerHTML={{__html: item.description}} />}>
              <FontAwesomeIcon icon={faInfoCircle} />
            </Tooltip>
          </div>
        : ''}
      </div>
    ))}
    </div>
    <button disabled={disabled} className="blue-button action-button" onClick={onClick}>{action}</button>
  </div>
)
